import { AlertCircle, RefreshCw, X } from 'lucide-react'

interface Props {
  message: string
  onRetry?: () => void
  onDismiss?: () => void
  title?: string
}

export default function ErrorAlert({ message, onRetry, onDismiss, title = 'Something went wrong' }: Props) {
  return (
    <div
      role="alert"
      className="flex items-start gap-3 p-4 rounded-xl bg-rose/10 border border-rose/20 text-sm"
    >
      <AlertCircle size={16} className="text-rose-light shrink-0 mt-0.5" aria-hidden />
      <div className="flex-1 min-w-0">
        <p className="font-medium text-rose-light">{title}</p>
        <p className="text-text-secondary mt-0.5 text-xs">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-2 flex items-center gap-1.5 text-xs text-blue-light hover:underline"
          >
            <RefreshCw size={11} aria-hidden /> Try again
          </button>
        )}
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="p-0.5 text-text-muted hover:text-text-primary transition-colors"
          aria-label="Dismiss error"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
